import 'css-chunksrc/client/pages/obsPage/loader/styles.scss';export default {
  "loader": "_loader_1et93_1",
  "unit": "_unit_1et93_5",
  "indented": "_indented_1et93_11"
};